/** A–Z optional cuisine preferences for Save My Food (must match NutritionLab::CuisineTypes::OPTIONS). */
export const SAVE_MY_FOOD_CUISINE_TYPES = [
	'American',
	'Chinese',
	'French',
	'Indian',
	'Italian',
	'Japanese',
	'Korean',
	'Mediterranean',
	'Mexican',
	'Thai',
	'Vietnamese'
];
